import React, { useState } from 'react';
import DatePicker from 'react-datepicker'; // Install react-datepicker using: npm install react-datepicker
import 'react-datepicker/dist/react-datepicker.css';

function Table({ data, onSave }) {
  const [selectedDates, setSelectedDates] = useState({});
  const [error, setError] = useState('');

  // Handle date change
  const handleDateChange = (date, id) => {
    setSelectedDates((prevDates) => ({
      ...prevDates,
      [id]: date,
    }));
  };

  const handleSave = () => {
    // Check if all dates are selected
    const missingDates = data.some((item) =>
      Array.from({ length: item.quantity }).some(
        (_, index) => !selectedDates[`${item.id}-${index}`]
      )
    );

    if (missingDates) {
      setError('All installation dates are required.');
      return;
    }

    setError(''); // Clear any existing error messages

    // Map data to AcDetails format
    const savedItems = data.flatMap((item) =>
      Array.from({ length: item.quantity }).map((_, index) => ({
        ac_type: item.acType,
        subscription_price: item.subscription_plan,
        fixedPriceAfter3Years: item.priceAfter3Years,
        model: item.acType === 'Split' ? `S${item.ton}` : item.acType === 'Cassette' ? `C${item.ton}` : null,
        installation_price: item.installetionCharge,
        plan_year: item.plan,
        deposit: item.depositamount,
        quantity: 1,
        totalAmount: item.totalAmount,
        dateOfInstallation: selectedDates[`${item.id}-${index}`],
      }))
    );

    // Pass the saved items to the parent via the onSave callback
    onSave(savedItems);
  };

  return (
    <div className="bg-white shadow-md rounded-xl border-2 p-6">
      <table border="1" style={{ width: '100%', textAlign: 'left' }}>
        <thead>
          <tr>
            <th>AC Type</th>
            <th>Ton</th>
            <th>Date of Installation</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) =>
            Array.from({ length: item.quantity }).map((_, index) => (
              <tr key={`${item.id}-${index}`}>
                <td>{item.acType}</td>
                <td>{item.ton}</td>
                <td>
                  <DatePicker
                    selected={selectedDates[`${item.id}-${index}`]}
                    onChange={(date) => handleDateChange(date, `${item.id}-${index}`)}
                    dateFormat="yyyy-MM-dd"
                    placeholderText="Select Date"
                  />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      {error && <p className="text-red-500 mt-2">{error}</p>}
      <button onClick={handleSave} className="mt-4 bg-blue-500 text-white px-4 py-2 rounded">
        Save Installation Dates
      </button>
    </div>
  );
}

export default Table;
